<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     生产管理--生产报表
  +---------------------------------------------------------------------------------------
-->

<template>
	<div class="mes-report header-padding">

		<f-page-header />

		<div class="report-container">
			<!-- 筛选器 -->
			<div class="filter-container">

				<div class="flex filter-box" style="height: 40px;">
					<span class="filter-item">
						<f-radio-btn-group v-model="type" :groups="radios" type="major" @change="changeType" class="mr" />
					</span>

					<span class="filter-item">

						<el-date-picker v-show="type == 1" v-model="date" type="date" placeholder="请选择日期" style="width: 230px;" :picker-options="options" :clearable="false" @change="fetchData" />

						<el-date-picker v-show="type == 2" v-model="date" type="week" :format="startDate + ' - ' + endDate" placeholder="请选择周数" style="width: 230px;" :picker-options="options2" :clearable="false" @change="fetchData" />

						<el-date-picker v-show="type == 3" v-model="date" type="month" placeholder="请选择月份" style="width: 230px;" :picker-options="options3" :clearable="false" @change="fetchData" />

					</span>

				</div>

			</div>

			<el-card v-loading="loading" class="table-card" shadow="never">

				<!-- 工单 -->
				<div class="front-line font-18 mb-lg">工单</div>

				<div class="funnels">
					<div class="funnel funnel-send flex align-items-center">
						<div class="send-hd header flex-center">
							<div class="text-white title font-16">派工</div>
						</div>
						<div class="send-bd body flex-center">
							<div class="total flex justify-content-center column">
								<div class="text-muted">合计</div>
								<div class="number font-24 text-bold mt-xs">{{ workorder.cnt_workorder_plan_tostart_total }}</div>
							</div>
						</div>
						<div class="send-ft foot"></div>
					</div>
					<div class="funnel funnel-start flex align-items-center mt" style="margin-left: 17px;">
						<div class="start-hd header flex-center">
							<div class="text-white title font-16">开工</div>
						</div>
						<div class="start-bd body flex-center">
							<div class="total flex justify-content-center column">
								<div class="text-muted">合计</div>
								<div class="number font-24 text-bold mt-xs">{{ workorder.cnt_workorder_plan_started }}</div>
							</div>
						</div>
						<div class="start-ft foot flex">
							<div class="stat ml-hg flex justify-content-center column">
								<div class="text-muted">超时未开工</div>
								<div class="number font-24 text-bold mt-xs">{{ workorder.cnt_workorder_plan_started }}</div>
							</div>
							<div class="stat ml-lg flex justify-content-center column">
								<div class="text-muted">开工超时</div>
								<div class="number font-24 text-bold mt-xs">{{ workorder.cnt_workorder_plan_started }}</div>
							</div>
						</div>
					</div>
					<div class="funnel funnel-finish flex align-items-center mt" style="margin-left: 34px;">
						<div class="finish-hd header flex-center">
							<div class="text-white title font-16">完工</div>
						</div>
						<div class="finish-bd body flex-center">
							<div class="total flex justify-content-center column">
								<div class="text-muted">合计</div>
								<div class="number font-24 text-bold mt-xs">{{ workorder.cnt_workorder_plan_ended }}</div>
							</div>
						</div>
						<div class="finish-ft foot flex">
							<div class="stat ml-hg flex justify-content-center column">
								<div class="text-muted">超时未完工</div>
								<div class="number font-24 text-bold mt-xs">{{ workorder.cnt_workorder_plan_not_end }}</div>
							</div>
							<div class="stat ml-lg flex justify-content-center column">
								<div class="text-muted">完工超时</div>
								<div class="number font-24 text-bold mt-xs">{{ workorder.cnt_workorder_plan_ended_overtime }}</div>
							</div>
						</div>
					</div>
					<div class="funnel funnel-qc flex align-items-center mt" style="margin-left: 51px;">
						<div class="qc-hd header flex-center">
							<div class="text-white title font-16">质检</div>
						</div>
						<div class="qc-bd body flex-center">
							<div class="total flex justify-content-center column">
								<div class="text-muted">合计</div>
								<div class="number font-24 text-bold mt-xs">{{ workorder.cnt_workorder_inspect_total }}</div>
							</div>
						</div>
						<div class="qc-ft foot flex">
							<div class="stat ml-hg flex justify-content-center column">
								<div class="text-muted">产量异常</div>
								<div class="number font-24 text-bold mt-xs">{{ workorder.cnt_workorder_inspect_abnormal_num }}</div>
							</div>
							<div class="stat ml-lg flex justify-content-center column">
								<div class="text-muted">有不合格品</div>
								<div class="number font-24 text-bold mt-xs">{{ workorder.cnt_workorder_inspect_abnormal_defective }}</div>
							</div>
						</div>
					</div>
				</div>
				<el-alert class="mt-lg mb-lg" type="info" :closable="false">
					<div slot="title" class="flex align-items-center">
						<i class="el-icon-warning text-danger font-lg" />
						<span class="ml-xs text-black">小贴士</span>
					</div>
					<div>{{'数据统计范围 ' + range + '，在此期间计划开工的工单'}}</div>
				</el-alert>

				<el-divider></el-divider>
				<!-- 工件 -->
				<div class="front-line font-18 mt-lg mb-lg">工件</div>

				<div class="mb-lg">
					<el-row>
						<el-col :span="11">
							<div class="piece mt flex">
								<div class="flex1">
									<div class="">实际生产</div>
									<div class="flex mt align-items-end" style="height: 35px">
										<div class="number font-28 text-bold">
											{{product.sum_num_ended_mfg}}
										</div>
										<div class="text-muted unit ml-sm">件</div>
									</div>
								</div>
								<div class="flex1">
									<div class="">其中</div>
									<div class="flex mt ml align-items-end" style="height: 25px">
										<div class="mr unit-s">
											良品数
										</div>
										<div class="number font-20" :class="{ 'text-success': product.sum_num_ended_mfg_non_defective }">
											{{product.sum_num_ended_mfg_non_defective}}
										</div>
										<div class="text-muted unit-s ml-sm">件</div>
									</div>
									<div class="flex mt ml align-items-end" style="height: 25px">
										<div class="mr unit-s">
											次品数
										</div>
										<div class="number font-20" :class="{ 'text-danger': product.sum_num_ended_mfg_defective }">
											{{product.sum_num_ended_mfg_defective}}
										</div>
										<div class="text-muted unit-s ml-sm">件</div>
									</div>
									<div class="flex mt ml align-items-end" style="height: 25px">
										<div class="mr unit-s">
											待质检
										</div>
										<div class="number font-20" :class="{ 'text-warning': product.sum_num_ended_mfg_toinspect }">
											{{product.sum_num_ended_mfg_toinspect}}
										</div>
										<div class="text-muted unit-s ml-sm">件</div>
									</div>
								</div>
							</div>
						</el-col>
						<el-col :span="13">
							<div class="flex justify-content-center">
								<ReportPie :good="product.sum_num_ended_mfg_non_defective" :bad="product.sum_num_ended_mfg_defective" :toinspect="product.sum_num_ended_mfg_toinspect" />
							</div>
						</el-col>
					</el-row>
				</div>

				<template v-if="type == 1">
					<el-divider></el-divider>
					<div class="front-line font-18 mt-lg mb-lg">次品明细</div>

					<el-table ref="detailTable" :data="list" tooltip-effect="dark" class="padding-small" :show-header="false" style="width: 100%">
						<el-table-column type="index" label="#" width="60" />

						<el-table-column label="title" min-width="160" show-overflow-tooltip>
							<template slot-scope="scope">
								{{ scope.row.workorder_no + ' / ' + scope.row.workorder_title}}
							</template>
						</el-table-column>

						<el-table-column label="title" min-width="160" show-overflow-tooltip>
							<template slot-scope="scope">
								<div class="text-danger">{{ scope.row.sum_num_ended_mfg_defective }} 件不合格</div>
							</template>
						</el-table-column>

						<template slot="empty">
							<img class="image huger mt-lg" src="@/assets/empty.png">
							<div class="font-md mb-hg">{{ startDate }} 没有次品</div>
						</template>
					</el-table>

				</template>
			</el-card>
		</div>

	</div>
</template>

<script>
import dayjs from 'dayjs'
import { getReportApi } from '@/api/mes/reportApi'
import weekday from "dayjs/plugin/weekday";
import "dayjs/locale/zh-cn";

const nowDate = parseInt((new Date().getTime() / 1000).toString())
const yesterday = nowDate - (nowDate % 86400) - 3600 * 8 - 3600 * 24
const last90 = nowDate - (nowDate % 86400) - 3600 * 8 - 3600 * 24 * 90
const last360 = nowDate - (nowDate % 86400) - 3600 * 8 - 3600 * 24 * 360
let nowThisWeek = new Date().getDay()
let a = nowDate - (nowThisWeek - 1) * 86400
let thisWeek = a - (a % 86400) - 3600 * 8 //本周星期一的时间

const lastWeek = thisWeek - 86400 * 7 //上周星期一的时间
console.log('lastWeek: ', lastWeek);


let nowMonthDate = new Date()
let getMonth = nowMonthDate.getMonth() + 1
nowMonthDate.setMonth(getMonth - 2);
nowMonthDate.setDate(1);
nowMonthDate.setHours(0);
nowMonthDate.setSeconds(0);
nowMonthDate.setMinutes(0);
const lastMonth = parseInt((nowMonthDate / 1000).toString());

export default {
	name: "MesReport",

	components: {
		ReportPie: () => import('./components/ReportPie')
	},

	data () {
		var disabledDate = (date) => {
			if (this.disablerange) {
				if (this.disablerange.length === 1) {
					return date.getTime() < this.disablerange[0] * 1000
				} else {
					return date.getTime() < this.disablerange[0] * 1000 || date.getTime() > this.disablerange[1] * 1000
				}
			} else {
				return false
			}
		}
		var disabledWeek= (date) => {
			return date.getTime() >= thisWeek * 1000 || date.getTime() < last360 * 1000
		}
		var disabledMonth = (date) => {
			if (this.monthRange) {
			if (this.monthRange.length === 1) {
				return date.getTime() < this.monthRange[0] * 1000
			} else if (this.monthRange.length === 2) {
				return date.getTime() < this.monthRange[0] * 1000 || date.getTime() > this.monthRange[1] * 1000
			} else {
				return date.getTime() > new Date().setMonth(new Date().getMonth() - 1) || date.getTime() < last360 * 1000
				}
			} else {
				return false
			}
		}
		return {
			workorder: {},
			product: {},

			options: {
				disabledDate: disabledDate
			},
			options2: {
				disabledDate: disabledWeek,
				'firstDayOfWeek': 1
			},
			options3: {
				disabledDate: disabledMonth
			},
			disablerange: [last360, yesterday],
			monthRange: [],
			type: 1,
			date: new Date(yesterday * 1000),
			list: [],
			radios: [
				{ value: 1, title: '日报' },
				{ value: 2, title: '周报' },
				{ value: 3, title: '月报' }
			],
			loading: false
		}
	},

	computed: {
		range () {
			dayjs.extend(weekday);
			dayjs.locale('zh-cn');
			if (this.type == 1) return dayjs(this.date).startOf('day').format('MM月DD日')

			if (this.type == 2) return dayjs(this.date).startOf('week').format('MM月DD日') + ' - ' + dayjs(this.date).endOf('week').format('MM月DD日')

			if (this.type == 3) return dayjs(this.date).startOf('month').format('MM月DD日') + ' - ' + dayjs(this.date).endOf('month').format('MM月DD日')
		},

		startDate () {
			dayjs.extend(weekday);
			dayjs.locale('zh-cn');
			if (this.type == 1) return dayjs(this.date).startOf('day').format('YYYY-MM-DD')
			if (this.type == 2) return dayjs(this.date).startOf('week').format('YYYY-MM-DD')
			if (this.type == 3) return dayjs(this.date).startOf('month').format('YYYY-MM-DD')
		},

		endDate () {
			dayjs.extend(weekday);
			dayjs.locale('zh-cn');
			if (this.type == 1) return dayjs(this.date).endOf('day').format('YYYY-MM-DD')
			if (this.type == 2) return dayjs(this.date).endOf('week').format('YYYY-MM-DD')
			if (this.type == 3) return dayjs(this.date).endOf('month').format('YYYY-MM-DD')
		}
	},

	created () {
		this.fetchData()
	},

	watch: {
	},

	methods: {
		fetchData () {
			this.loading = true
			const query = {
				type: this.type,
				timestamp: this.date.getTime() / 1000
			}
			getReportApi(query).then(res => {
				this.loading = false
				if (!res.errno) {
					this.product = Object.assign({}, res.data.workpiece)
					this.workorder = Object.assign({}, res.data.workorder)
					this.list = res.data.defective
				}
			})
		},

		changeType () {
			if (this.type == 1) this.date = new Date(yesterday * 1000)
			if (this.type == 2) this.date = new Date((thisWeek - 86400) * 1000)
			if (this.type == 3) this.date = new Date(lastMonth * 1000)
			this.fetchData()
		}
	}

}
</script>

<style lang="scss" scoped>
/deep/ .el-table {
	border-top: 0;
	border-left: 0;
	border-right: 0;
}
/deep/ .el-table__empty-block {
	border-bottom: 0;
}
.mes-report {
	position: relative;
	.report-container {
		width: 1080px;
		margin: 0 auto;
	}
	.funnels {
		.funnel {
			.title {
				margin-top: -80px;
			}
			.total {
				width: 50px;
				transform: skewX(12deg);
			}
			.stat {
				height: 80px;
				width: 100px;
			}
			.header {
				height: 0;
				border-right: 17px solid transparent;
				border-left: 17px solid transparent;
			}
			.body {
				height: 80px;
				margin-left: -9px;
				margin-right: -9px;
				transform: skewX(-12deg);
			}
			.foot {
				height: 0;
				border-left: 17px solid transparent;
				flex: auto;
			}
		}
		.funnel-send {
			.send-hd {
				width: 208px;
				border-top: 80px solid #997bec;
			}
			.send-bd {
				width: 192px;
				background: rgba($color: #997bec, $alpha: 0.6);
			}
			.send-ft {
				border-bottom: 80px solid rgba($color: #997bec, $alpha: 0.2);
			}
		}
		.funnel-start {
			.start-hd {
				width: 174px;
				border-top: 80px solid #409eff;
			}
			.start-bd {
				width: 192px;
				height: 80px;
				margin-left: -9px;
				margin-right: -9px;
				transform: skewX(-12deg);
				background: rgba($color: #409eff, $alpha: 0.6);
			}
			.start-ft {
				height: 0;
				border-left: 17px solid transparent;
				flex: auto;
				border-bottom: 80px solid rgba($color: #409eff, $alpha: 0.2);
			}
		}

		.funnel-finish {
			.finish-hd {
				width: 140px;
				border-top: 80px solid #07c160;
			}
			.finish-bd {
				width: 192px;
				background: rgba($color: #07c160, $alpha: 0.6);
			}
			.finish-ft {
				border-bottom: 80px solid rgba($color: #07c160, $alpha: 0.2);
			}
		}

		.funnel-qc {
			.qc-hd {
				width: 106px;
				border-top: 80px solid #e6a23c;
			}
			.qc-bd {
				width: 192px;
				background: rgba($color: #e6a23c, $alpha: 0.6);
			}
			.qc-ft {
				border-bottom: 80px solid rgba($color: #e6a23c, $alpha: 0.2);
			}
		}
	}
	.piece {
		height: 320px;
		width: 100%;
		background: #f8f9fc;
		padding: 20px;
		border-radius: 4px;
		.unit {
			line-height: 24px;
		}
		.unit-s {
			line-height: 18px;
		}
	}
}
</style>
